import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  seniorContainer: {
    width: '100%',
    margin: '0 auto',
    height: '100%',
    alignItems: 'center',
    background: 'rgba(246,248,249,1)',
    position: 'relative',
    minHeight: '1080px',
  },
  body: {
    background: 'rgba(246,248,249,1)',
  },
  header: {
    width: '100%',
    height: '330px',
    alignItems: 'center',
    backgroundImage: `url(${require('./assets/headerBg.png')})`,
    backgroundSize: '1920px 330px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundColor: 'rgba(246,248,249,1)',
  },
  headerTitle: {
    width: '100%',
    alignItems: 'flex-start',
  },
  titleLogo: {
    marginTop: 28,
    marginLeft: 20,
    width: '58px',
  },
  hyLogo: {
    height: 96,
  },
  title: {
    width: '378px',
    marginTop: '24px',
  },
  date: {
    marginTop: '20px',
    fontSize: '14px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(255,255,255,1)',
    lineHeight: '19px',
  },
  scores: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-around',
    fontFamily: 'PingFangSC',
    alignItems: 'center',
    margin: 'auto',
  },
  score: {
    position: 'relative',
    flex: 1,
    height: 65,
    alignItems: 'center',
  },
  interval: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 1,
    height: 15,
    background: 'rgba(220,230,236,1)',
  },
  scoreItem: {
    width: '100%',
    alignItems: 'center',
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: '45px',
    fontFamily: 'PingFangSC-Semibold',
    color: 'rgba(50,54,58,1)',
  },
  totalScore: {
    color: 'rgba(51,153,255,1)',
  },
  subjectScore: {
    color: '#000',
  },
  scoreTitle: {
    fontSize: '12px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(129,140,150,1)',
    lineHeight: '17px',
  },
  surveyContainer: {
    width: 1000,
    height: 160,
    background: 'rgba(255,255,255,1)',
    boxShadow: '0px 2px 20px 0px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    verticalAlign: 'center',
    marginTop: '-80px',
  },
  subjectContainer: {
    width: 1000,
    height: 288,
    background: 'rgba(255,255,255,1)',
    boxShadow: '0px 2px 20px 0px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    flexDirection: 'row',
    marginTop: '15px',
    padding: '40px 80px',
  },
  subject: {
    flex: 1,
    alignItems: 'center',
  },
  subjectTitle: {
    fontSize: '16px',
    fontFamily: 'PingFang-SC-Medium',
    fontWeight: 500,
    color: 'rgba(135,143,152,1)',
    lineHeight: '22px',
  },
  accuracy: {
    margin: '32px 0 12px',
    width: 120,
    height: 120,
  },
  answer: {
    flexDirection: 'row',
    fontSize: '16px',
    fontFamily: 'PingFang-SC-Medium',
    fontWeight: 500,
    color: 'rgba(50,54,58,1)',
    lineHeight: '22px',
  },
  correct: {
    color: '#3399FF',
  },
  suggestContainer: {
    width: 1000,
    height: 188,
    background: 'rgba(255,255,255,1)',
    boxShadow: '0px 2px 20px 0px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '15px',
    padding: '40px 80px',
    marginBottom: '84px',
  },
  school: {
    width: 100,
    height: 100,
    backgroundSize: '100% 100%',
    fontSize: '16px',
    fontFamily: 'PingFangSC-Semibold',
    fontWeight: '600',
    color: 'rgba(255,255,255,1)',
    lineHeight: '24px',
    textAlign: 'center',
    verticalAlign: 'middle',
    padding: '26px 13px',
  },
  recommend: {
    fontSize: '18px',
    fontFamily: 'PingFang-SC-Medium',
    fontWeight: 500,
    color: 'rgba(50,54,58,1)',
    lineHeight: '25px',
    flexDirection: 'row',
  },
  suggestSchool: {
    color: '#3399FF',
    flexDirection: 'row',
  },
  tip: {
    fontSize: '14px',
    fontFamily: 'PingFang-SC-Medium',
    fontWeight: '500',
    color: 'rgba(195,204,209,1)',
    lineHeight: '20px',
    marginTop: '20px',
  },
  schoolContainer: {
    position: 'absolute',
    top: '298px',
    left: '50%',
    transform: 'translateX(425px)',
  },
  schoolItem: {
    flexDirection: 'row',
    marginBottom: 15,
    alignItems: 'center',
  },
  schoolIMG: {
    width: 75,
    height: 75,
    marginRight: 15,
  },
  bottom: {
    width: '100%',
    height: 83,
    textAlign: 'center',
    justifyContent: 'center',
    backgroundImage: `url(${require('./assets/bottomBg.png')})`,
    backgroundSize: '1920px 83px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    fontSize: '12px',
    fontFamily: 'PingFangSC-Regular',
    fontWeight: 400,
    color: 'rgba(135,143,152,1)',
    lineHeight: '17px',
  },
});



// WEBPACK FOOTER //
// ./src/components/report/senior_report/styles.js